<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>




        <!-- 测试开始 -->
        <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;background-color: white;height: 20vh;padding-top: 10vh;">
            <img style="margin-bottom: 4vh; height: 4vh; width: auto" src="../../assets/greenmanufacturinglogo.png" alt="">
            <div style="font-size: 2rem;">谱祺“可持续的旅行”理念</div>
        </div>
       
   
    <!-- v-for 循环部分 -->
    <div v-for="(section, index) in sections" :key="index" class="" ref="sectionElement"  style="display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh;
   ">
   
      <div style="display: flex; justify-content: space-between; align-items: flex-start;  position: relative; ">
            <!-- 文本部分 -->
            <div style="width: 50%; ">
          <div style="margin-bottom: 10%; font-size: 1.5rem;">{{ isEnglish ?section.titleen: section.title }}</div>
          <div style="text-align: justify;line-height: 1.6 ;color: gray; font-size: 1rem; width: 25vw;word-wrap: break-word; word-break: break-all; white-space: pre-wrap;" >{{ isEnglish ?section.contenten:section.content }}</div>
        </div>
        <!-- 图片部分 -->
        <div style="width: 45%; padding-right: 1%;">
          <img :src="section.imageSrc" style="width: 100%; height: auto;">
        </div>

            <!-- 下移的下划线 -->
     <div class="xiahuaxian"  v-if="index !== sections.length - 1" style="position: absolute; width: 100%; border-bottom: 1px solid gray; margin-top: 57vh;"></div>
    
      </div>
    
    </div>

<!-- 测试结束 -->


    <!-- 一屏幕滑动的代码开始 -->
            <!-- <img :src="imageUrlone" alt="" class="imgoneru">
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh;background-color: white;">
            <img style="margin-right: -2vh; height: 10vh; width: auto" src="../../assets/greenmanufacturinglogo.png" alt="">
            <div style="font-size: 2rem;">谱祺“可持续的旅行”理念</div>
        </div>
       
   
  v-for 循环部分 
    <div v-for="(section, index) in sections" :key="index" class="section" ref="sectionElement">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; height: 100vh;  padding-top: 60vh; ">
             文本部分 
            <div style="width: 45%;">
          <div style="margin-bottom: 10%; font-size: 1.5rem;">{{ isEnglish ?section.titleen: section.title }}</div>
          <div style="color: gray; font-size: 0.8rem; width: 30vw;word-wrap: break-word; word-break: break-all; white-space: pre-wrap;" >{{ isEnglish ?section.contenten:section.content }}</div>
        </div>
         图片部分
        <div style="width: 45%; padding-left: 0%;">
          <img :src="section.imageSrc" style="width: 100%; height: auto;">
        </div>

    
      </div>
    </div>
-->
     
    <!-- 一屏幕滑动的代码结束 -->
       
        <!-- 添加更多 section -->
        <!-- <Bottom2></Bottom2> -->
        <Bottom style="margin-top: 13vh;"></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
    // import Bottom2 from "@/view/public/heardpc.vue";
    // import Header2 from '../public/newheaderx.vue'
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    export default {
        computed: {
           // 从 Vuex 的 state 中获取 isEnglish 数据
           ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return { 
                imageUrlone: require('../../assets/pic-15.png'),
              
                isScrolled: false,
                sections: [
            {
               
                imageSrc: require('../../assets/pic-Green R&D1.png'), // 图片路径
                title: '环境保护理念',
                titleen: '环境保护理念2',
                content: '将“可持续”的思维和行动融入旅行，为我们共同的地球，选择更环保的行为方式和用品。同时，谱祺期望，我们的伙伴、用户和旅游业的同仁，加入到“可持续的旅行”倡议中，共同守护蓝色星球。',
                contenten: '2谱祺拥有自主的产品研发团队，无论是外观设计，还是结构开发，谱祺始终立足于用户自信体验和品牌定位，用工匠精神打造卓越的产品。',
            },
            {
                imageSrc: require('../../assets/pic-Green R&D2.png'), // 图片路径
                title: '绿色生产',
                titleen: '产品研发',
                content: '谱祺重视主产品生产过程中对原材料环保责任的管控，充分使用可回收的材料，同时使用环保水性漆进行表面处理，并且推行材料溯源管理和6S生产管理模式。',
                contenten: '谱祺拥有自主的产品研发团队，无论是外观设计，还是结构开发，谱祺始终立足于用户自信体验和品牌定位，用工匠精神打造卓越的产品。',
            
            },
            {
                imageSrc: require('../../assets/pic-Green R&D3.png'), // 图片路径
                title: '品证环保',
                titleen: '产品研发',
                content: '更高的产品质量不仅是对品牌的永诺，同时也是对环保的责任，更高的品质意味着更加耐用，减少消耗和排放。\n谱祺产品拒绝过度包装，同时充分利用电子媒介取代纸质印刷。',
                contenten: '谱祺拥有自主的产品研发团队，无论是外观设计，还是结构开发，谱祺始终立足于用户自信体验和品牌定位，用工匠精神打造卓越的产品。',
            
            },
            {
                imageSrc: require('../../assets/pic-Green R&D4.png'), // 图片路径
                title: '合作责任',
                titleen: '产品研发2',
                content: '无论是对企业员工，还是对合作伙伴，谱祺始终传递共同环保责任的合作理念，将环保责任落实到企业的日常经营活动之中。',
                contenten: '谱祺拥有自主的产品研发团队，无论是外观设计，还是结构开发，谱祺始终立足于用户自信体验和品牌定位，用工匠精神打造卓越的产品。',
            
            },
          
          
            // 可以添加更多条目
        ]

            };
        },

        mounted() {
            this.fetchData();
            this.initObserver(); // 初始化观察器
    window.addEventListener('wheel', this.initObserver, { passive: false });
            // window.addEventListener('wheel', this.handleScroll, { passive: false });
            // this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.initObserver);
            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {

            async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/greenmanufacturing`);
                const data = response.data;
                // console.log(data)
                if (data && data.length > 0) {
                    // 处理 banner 图片
                    this.imageUrlone = `${apiUrls.devApi}${data[0].imageUrlone}`;

                    // 处理 locations 数据
                    this.sections=data.map(item=>({
                        // id:item.id,
                        title:item.title,
                        titleen:item.titleen,
                        content:item.content,
                        contenten:item.contenten,
                        imageSrc:`${apiUrls.devApi}${item.imageSrc}`
                    }))
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        }, 


            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
                const ss=   options.root.scrollTop;
                if(ss!=0){
                    this.isScrolled = true;
                }else{ this.isScrolled=false;}


            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }
                     // 获取每个section元素
                     const sectionElements = this.$refs.sectionElement;
                     // 计算当前应该滚动到哪个section
                     const direction = event.deltaY > 0 ? 1 : -1; // 根据滚动方向确定是向上还是向下
                     // 计算滚动后的位置
                    this.scrollCount += direction;
                    // 防止越界
                    if (this.scrollCount < 0) this.scrollCount = 0;
                    if (this.scrollCount >= sectionElements.length) this.scrollCount = sectionElements.length - 1;

                    // 使用 scrollIntoView 确保滚动到该 section
                    const targetSection = sectionElements[this.scrollCount];
                    if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 使目标元素在视口的垂直方向居中
                        inline: 'center' // 水平方向居中（可选）
                    });
                    }




                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                  

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                       




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
/* 台式大电脑 (1200px 及以上) 样式 */
@media (min-width: 1600px) {
    .xiahuaxian{
        margin-top: 54vh!important;
    }
}
/* 第一张图片开始 */
.imgone img{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
.imgoneru{
    width: 100%;
        height: auto;
        /* margin-bottom: 9vh; */
}
/* 第一张图片结束 */
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;
background-color: white;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
